import React, { Component } from 'react';
import _                    from 'lodash';

export default class TableHolder extends Component{

    constructor(props){
        super(props);
        this.drawTable = this.drawTable.bind(this);
    }

    componentDidMount(){
        if ((typeof this.props.google === 'undefined') || (typeof this.props.google.visualization === 'undefined')) {
            this.props.google.charts.load('current', {packages: ['corechart','table','bar']});
            this.props.google.charts.setOnLoadCallback(this.drawTable);
        }
    }

    componentDidUpdate(){
        this.drawTable();
    }

    drawTable(){
        let cssClassNames = {
            'headerRow':'blue-bg',
            'tableRow': ''
        };
        let options = {
            'showRowNumber' : true,
             'width'        : '100%',
             'height'       : '100%',
            'allowHtml'     : true,
            'cssClassNames' : cssClassNames
        };
        let data          = new this.props.google.visualization.DataTable();
        let columns       = this.props.columns;
        let colFormatters = this.props.colFormatters;

        Object.keys(columns).forEach(columnName => {
            data.addColumn(columns[columnName]);
        });
        data.addRows(this.props.tableData);

        colFormatters.forEach(colFormatter =>{
             colFormatter.formatter.format(data,colFormatter.colIndex);
        });

        let table = new this.props.google.visualization.Table(document.getElementById('table_div'));

        table.draw(data, options );


    }

    render(){
        return (
			<div className="container-fluid charts-table-holder">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <div className={"table-responsive"}  id = "table_div"ref={(c) => this._table_div = c} ></div>
                    </div>
                </div>
            </div>
		);
    }

}



// WEBPACK FOOTER //
// src/components/visualization/table-holder.js